import { Component, OnInit ,Input} from '@angular/core';
import { ToastService }   from 'ng-uikit-pro-standard';
import { UploadService } from './upload.service';
import { Subscription } from 'rxjs';
@Component({
    selector: 'upload-icon',
    templateUrl: 'upload.component.html',
    styles: [`
    a {
        position: relative;
        display: block;
        padding: 10px 15px;
    }
    `]
})

export class UploadComponent implements OnInit {

    subscriptionSprig: Subscription;
    subscription: Subscription;
    popoverOpen: boolean = false;
    @Input() sprigInfo: any = {};

    constructor(
        public toastr: ToastService,
        private UploadService: UploadService,
    ) {
        this.subscription = this.UploadService.sendData.subscribe(data => {
            this.setData(data);
        });
    }

    faIcon: string = "cloud text-green";
    lastIconDetail: any = {};
    uploadCount: number = 0;
    mdbTooltip: string = ""
    getSprigInfo(res) {
        if (res.operation == 'icon') {
            this.faIcon = res.data.icon;
            this.mdbTooltip = res.data.response;
            this.lastIconDetail = { icon: res.data.icon, mdbTooltip: res.data.response };
        }
        else if (res.operation == 'count') {
            this.uploadCount = res.data;
        }
    }

    setData(data) {
        if (data.operation == 'upload') {
            this.setFileList(data.data);
        }
        else if (data.operation == 'progress') {
            this.setProgress(data);
        }
        else if (data.operation == 'done') {
            setTimeout(() => {
                this.popoverOpen = false;
            }, 1000);
            this.faIcon = this.lastIconDetail.icon;
            this.mdbTooltip = this.lastIconDetail.mdbTooltip;
        }

    }

    ngOnInit() {}

    ngOnChanges()
    {
        if(this.sprigInfo && this.sprigInfo.operation)
        this.getSprigInfo(this.sprigInfo)
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.subscription.unsubscribe();
        this.subscriptionSprig.unsubscribe();
    }
    files = [];
    setFileList(data) {
        this.files = data;
        this.popoverOpen = true;
    }

    setProgress(data) {
        this.files[data.index] = data.fileData;
    }
    onHidden() {
        this.popoverOpen = false;
    }
    onShown() {
        this.popoverOpen = true;
    }

    checkStatus(outputFile){
        if(outputFile.responseStatus>=400 && outputFile.responseStatus<=502){
            outputFile.progress.data.percentage = 'error';
            return 'danger';
        }
        return 'success';
    }

}